module.exports = __webpack_public_path__ + "img/bus-sm-grey.e2acc578.svg";